import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "../utils/toast";
import { addCaseParticipant, getCaseParticipants } from "../api";
import { wmErrorMessage } from "../api/wm-client";
import { AddParticipantBody } from "../dtos";

/** The case's applicants (PRIMARY + co-applicants) with their §PhoneLinking status. */
export const useCaseParticipants = (caseUid: string | null) =>
  useQuery({
    queryKey: ["nawy-now", "participants", caseUid],
    enabled: !!caseUid,
    queryFn: () => getCaseParticipants(caseUid as string),
  });

/**
 * Add a joint client / guarantor by mobile. Success invalidates the whole nawy-now
 * tree: the participants list refreshes AND the board re-derives — the co-applicant's
 * step block becomes applicable in the engine and reappears on the board.
 */
export const useAddParticipant = (caseUid: string | null) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: AddParticipantBody) => {
      if (!caseUid) return Promise.reject(new Error("No case to add to."));
      return addCaseParticipant(caseUid, body);
    },
    onSuccess: (_result, body) => {
      toast.success(
        body.type === "JOINT" ? "Joint client added" : "Guarantor added"
      );
      queryClient.invalidateQueries({ queryKey: ["nawy-now"] });
    },
    onError: (error: unknown) => toast.error(wmErrorMessage(error)),
  });
};
